<div class="flex gap-4">
  @if (actions() | onlyVisibleActionButtons | async; as actions) {
    @for (action of actions ?? []; track action.key) {
      <app-action-button [action]="action" />
    }
  }
</div>
